import { render } from "./Master.vue?vue&type=template&id=a295880a&scoped=true"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"

import "./Master.vue?vue&type=style&index=0&id=a295880a&scoped=true&lang=css"
import "./Master.vue?vue&type=style&index=1&id=a295880a&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a295880a"]])

export default __exports__